<template>
  <div>{{ slotParams.value | formatDate }}</div>
</template>
<script>
export default {
  props: ['slotParams']
};
</script>